// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"cfe5cb8b","787":"cc726c58","865":"55938751"}[chunkId] + ".chunk.js";
};